export const odooDiscrepancy = {
  "Odoo IN<>PO": `Odoo Factura<>Orden de Compra`,
  odoo_discrepancy_item_quantity_mismatch: `La cantidad '{{2}}' en el artículo '{{1}}' no coincide con la cantidad '{{4}}' en el pedido '{{3}}'`,
  odoo_discrepancy_item_unitprice_mismatch: `El precio unitario '{{2}}' en el artículo '{{1}}' no coincide con el precio unitario '{{4}}' en el pedido '{{3}}'`,
  odoo_inpo_discrepancy_item_poline_notattached: `Artículo '{{1}}' no tiene ninguna línea de orden de compra asociada.`,
  Odoo_INPO_Quantity_NotMatch:
    "Coincidir la cantidad de la línea de la factura con la cantidad de la línea de la orden de compra",
  Odoo_INPO_UnitPrice_NotMatch:
    "Coincidir el precio unitario de la línea de la factura con el precio unitario de la línea de la orden de compra",
  Odoo_INPO_Line_NotAttached: `Verificar si falta la línea de la orden de compra en la línea de la factura`,
  Odoo_INPO_Quantity_NotMatch_description:
    " The quantity invoiced on a line item does not match the quantity authorised on the corresponding Odoo PO line.",
  Odoo_INPO_UnitPrice_NotMatch_description:
    "The unit price on an invoice line differs from the unit price agreed on the matched Odoo purchase order line.",
  Odoo_INPO_Line_NotAttached_description:
    "An invoice line has no linked Odoo PO line reference, meaning it cannot be traced back to an authorised purchase order line.",
};
